import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import Button from '../components/ui/Button';
import { useEditor } from '../hooks/useEditor';
import { EDITOR_TABS } from '../utils/constants';

const EditorPage: React.FC = () => {
  const { activeTab, setActiveTab, currentCode, setCode, copyCode, lines, chars, language } = useEditor();

  return (
    <>
      <PageHeader
        title={<>Code <Highlight>Editor</Highlight></>}
        subtitle="Edit your React Native source files with live stats"
      />

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', overflow: 'hidden', marginBottom: 24 }}>
        {/* Tab bar */}
        <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', background: 'var(--surface2)', overflowX: 'auto' }}>
          {EDITOR_TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '11px 20px', fontSize: '0.78rem', fontWeight: 600,
                color: activeTab === tab.id ? 'var(--accent)' : 'var(--text-muted)',
                background: activeTab === tab.id ? 'var(--surface)' : 'transparent',
                borderBottom: activeTab === tab.id ? '2px solid var(--accent)' : '2px solid transparent',
                border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                fontFamily: 'var(--font-mono)', transition: 'all var(--transition-fast)',
              }}
            >
              {tab.label}
            </button>
          ))}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, padding: '8px 12px', alignItems: 'center' }}>
            <button onClick={copyCode} title="Copy" style={{ width: 30, height: 30, borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 13 }}>⎘</button>
          </div>
        </div>

        {/* Code area */}
        <textarea
          value={currentCode}
          onChange={(e) => setCode(e.target.value)}
          spellCheck={false}
          style={{
            fontFamily: 'var(--font-mono)', fontSize: '0.82rem', lineHeight: 1.7,
            background: 'transparent', border: 'none', outline: 'none', resize: 'none',
            width: '100%', padding: '20px 24px', color: 'var(--text)',
            minHeight: 320, caretColor: 'var(--accent)',
          }}
        />

        {/* Footer */}
        <div style={{ borderTop: '1px solid var(--border)', padding: '10px 20px', display: 'flex', gap: 20 }}>
          {[['Lines', lines], ['Chars', chars], ['Lang', language]].map(([k, v]) => (
            <span key={k} style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontFamily: 'var(--font-mono)' }}>
              {k}: <span style={{ color: 'var(--text-dim)' }}>{v}</span>
            </span>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <Button variant="primary" icon="⬢">Build APK</Button>
        <Button variant="secondary" icon="⎘" onClick={copyCode}>Copy Code</Button>
        <Button variant="secondary" icon="⊞">Format</Button>
      </div>
    </>
  );
};

export default EditorPage;
